var map = {
	".": [
		22974,
		9
	],
	"./": [
		22974,
		9
	],
	"./App": [
		17391,
		9
	],
	"./App.css": [
		44050,
		9
	],
	"./App.test": [
		20477,
		9,
		12,
		4,
		54
	],
	"./App.test.tsx": [
		20477,
		9,
		12,
		4,
		54
	],
	"./App.tsx": [
		17391,
		9
	],
	"./Const": [
		6709,
		9
	],
	"./Const.ts": [
		6709,
		9
	],
	"./OrganizationYearWeekPage": [
		8375,
		9
	],
	"./OrganizationYearWeekPage.tsx": [
		8375,
		9
	],
	"./SignalRContext": [
		60467,
		9
	],
	"./SignalRContext.tsx": [
		60467,
		9
	],
	"./SignalRService": [
		17559,
		9
	],
	"./SignalRService.ts": [
		17559,
		9
	],
	"./TopPlayerForLastYear": [
		63372,
		9
	],
	"./TopPlayerForLastYear.css": [
		10355,
		9
	],
	"./TopPlayerForLastYear.tsx": [
		63372,
		9
	],
	"./TopPlayerForPeriod": [
		69764,
		9
	],
	"./TopPlayerForPeriod.css": [
		89871,
		9
	],
	"./TopPlayerForPeriod.tsx": [
		69764,
		9
	],
	"./TopPlayerForPeriodAnim": [
		99379,
		9,
		379
	],
	"./TopPlayerForPeriodAnim.tsx": [
		99379,
		9,
		379
	],
	"./TopPlayersForLastYear": [
		74603,
		9
	],
	"./TopPlayersForLastYear.tsx": [
		74603,
		9
	],
	"./TopPlayersForPeriod": [
		90879,
		9
	],
	"./TopPlayersForPeriod.css": [
		52646,
		9,
		646
	],
	"./TopPlayersForPeriod.tsx": [
		90879,
		9
	],
	"./TopPlayersForPeriodAnim": [
		92144,
		9,
		144
	],
	"./TopPlayersForPeriodAnim.tsx": [
		92144,
		9,
		144
	],
	"./UgeDagPage": [
		62430,
		9
	],
	"./UgeDagPage.css": [
		8753,
		9
	],
	"./UgeDagPage.tsx": [
		62430,
		9
	],
	"./assets/background.png": [
		39528,
		1,
		528
	],
	"./assets/christmasparty.png": [
		34408,
		1,
		408
	],
	"./assets/christmasparty2.png": [
		29384,
		1,
		384
	],
	"./assets/christmaspartyafter.jpg": [
		67400,
		1,
		400
	],
	"./assets/christmaspartyloading10.jpg": [
		93909,
		1,
		909
	],
	"./assets/christmaspartyloading25.jpg": [
		30301,
		1,
		301
	],
	"./assets/christmaspartyloading42.jpg": [
		85472,
		1,
		472
	],
	"./assets/christmaspartyloading55.jpg": [
		83304,
		1,
		304
	],
	"./assets/christmaspartyloading67.jpg": [
		63147,
		1,
		147
	],
	"./assets/christmaspartyloading83.jpg": [
		41489,
		1,
		489
	],
	"./assets/christmaspartyloading99dot9.jpg": [
		54006,
		1,
		6
	],
	"./assets/home/dashboardbutton.png": [
		72228,
		1
	],
	"./assets/home/externaldashboard.png": [
		39971,
		1
	],
	"./assets/home/externaldashboarddialog.png": [
		5715,
		1
	],
	"./assets/home/externaldashboardinbrowser.png": [
		54748,
		1
	],
	"./assets/home/feedback.png": [
		7047,
		1
	],
	"./assets/home/feedbackbutton.png": [
		56443,
		1
	],
	"./assets/home/feedbackdialog.png": [
		60807,
		1
	],
	"./assets/home/feedbackdialogsubmitted.png": [
		15656,
		1
	],
	"./assets/home/privacy1.png": [
		94451,
		1
	],
	"./assets/home/privacy2.png": [
		19960,
		1
	],
	"./assets/home/privacy3.png": [
		92673,
		1
	],
	"./assets/home/privacy4.png": [
		25934,
		1
	],
	"./assets/home/privacy5.png": [
		99575,
		1
	],
	"./assets/home/privacy6.png": [
		10844,
		1
	],
	"./assets/home/privacybutton.png": [
		31396,
		1
	],
	"./assets/home/reportingbutton.png": [
		26734,
		1
	],
	"./assets/home/reportplayer.png": [
		54711,
		1
	],
	"./assets/home/reportplayerdialog.png": [
		17623,
		1
	],
	"./assets/home/reportplayerdialogsubmitted.png": [
		72440,
		1
	],
	"./assets/home/wwwappstore15pct.png": [
		81462,
		1
	],
	"./assets/home/wwwgoogleplay15pct.png": [
		94263,
		1
	],
	"./assets/home/wwwrankytank30pct.png": [
		79010,
		1
	],
	"./assets/home/wwwrankytanktitle.png": [
		13230,
		1
	],
	"./assets/home/wwwwoohooo.png": [
		75805,
		1
	],
	"./assets/kidschristmasparty.jpg": [
		97339,
		1,
		339
	],
	"./assets/rankytank.png": [
		36201,
		1
	],
	"./assets/snow-flake-192x192.png": [
		51762,
		1,
		762
	],
	"./assets/snow-flake2-192x192.png": [
		75936,
		1
	],
	"./assets/xmas-bottomright.png": [
		63991,
		1,
		991
	],
	"./assets/xmas-topleft.png": [
		22504,
		1,
		504
	],
	"./assets/xmas.png": [
		99009,
		1,
		9
	],
	"./dashboard": [
		48558,
		9
	],
	"./dashboard.css": [
		63835,
		9
	],
	"./dashboard.tsx": [
		48558,
		9
	],
	"./feedback": [
		40153,
		9
	],
	"./feedback.css": [
		57462,
		9
	],
	"./feedback.tsx": [
		40153,
		9
	],
	"./home": [
		1213,
		9
	],
	"./home.css": [
		24206,
		9
	],
	"./home.tsx": [
		1213,
		9
	],
	"./index": [
		22974,
		9
	],
	"./index.css": [
		59555,
		9
	],
	"./index.tsx": [
		22974,
		9
	],
	"./logo.svg": [
		69445,
		1,
		445
	],
	"./privacy": [
		20642,
		9
	],
	"./privacy.css": [
		51703,
		9
	],
	"./privacy.tsx": [
		20642,
		9
	],
	"./react-app-env.d": [
		55059,
		7,
		59
	],
	"./react-app-env.d.ts": [
		55059,
		7,
		59
	],
	"./reportWebVitals": [
		16469,
		9
	],
	"./reportWebVitals.ts": [
		16469,
		9
	],
	"./reporting": [
		33284,
		9
	],
	"./reporting.css": [
		68625,
		9
	],
	"./reporting.tsx": [
		33284,
		9
	],
	"./setupTests": [
		35374,
		9,
		12,
		405,
		374
	],
	"./setupTests.ts": [
		35374,
		9,
		12,
		405,
		374
	],
	"./useCaseInsensitiveSearchParams": [
		51350,
		9
	],
	"./useCaseInsensitiveSearchParams.ts": [
		51350,
		9
	],
	"./useImagePreloader": [
		53028,
		9
	],
	"./useImagePreloader.ts": [
		53028,
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 28969;
module.exports = webpackAsyncContext;